/**
 * Resize a textarea to fit its content, capped at a max height.
 *
 * Why the cap: an uncapped autogrow textarea keeps growing as the user types a
 * long note. Once it grows past the viewport, the browser scrolls the nearest
 * scroll container to keep the caret visible, so the page appears to "slowly
 * scroll down on its own" line by line while typing. Capping the height stops
 * that — past the cap the textarea scrolls internally instead.
 *
 * Override the cap per-field with a `data-autogrow-max="<px>"` attribute.
 */
export function applyAutogrow(el: HTMLTextAreaElement, fallbackMax = 360): void {
  const max = Number(el.dataset.autogrowMax) || fallbackMax
  el.style.height = 'auto'
  const next = Math.min(el.scrollHeight, max)
  el.style.height = `${next}px`
  el.style.overflowY = el.scrollHeight > max ? 'auto' : 'hidden'
}
